// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerShipToAddressStyles } from "@vanmeter/Overrides/Widgets/Common/HeaderShipToAddress";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, ellipsis, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

headerShipToAddressStyles.shipToAddressWrapper = {
    css: css`
        display: flex;
        width: 100%;

        ${xScreen("lte", "md")} {
            display: block;
            text-align: left;
        }
    `,
};

headerShipToAddressStyles.titleLabelWrapper = {
    css: css`
        max-width: 450px;
        display: flex;

        ${xScreen("lte", "md")} {
            display: block;
            margin-bottom: 8px;
        }

        ${xScreen("gt", "lg")} {
            ${({ showBorder }: any) =>
                showBorder &&
                css`
                    & > *:last-child {
                        padding-right: 12px;
                        margin-right: 12px;
                        border-right: 1px solid ${color("common.border")};
                    }
                `}
        }
    `,
};

headerShipToAddressStyles.titleLabel = {
    ...fontConfig.smallSingleLine,
    css: css`
        white-space: nowrap;
        margin-right: 4px;
    `,
};

headerShipToAddressStyles.titleTypography = {
    ...fontConfig.smallSingleLine,
    weight: fontConfig.weight.bold,
    css: css`
        ${({ isNavigationDrawer }: any) =>
            !isNavigationDrawer &&
            css`
                ${ellipsis(1)};
                word-break: break-all;
            `}
    `,
};

headerShipToAddressStyles.titleClickable = {
    typographyProps: {
        ...fontConfig.smallSingleLine,
    },
    css: css`
        ${xScreen("lte", "md")} {
            display: flex;
            width: fit-content;
        }
    `,
};
